import React, { useMemo, useState } from "react";
import { Modal, Tabs } from "antd";
import BaseButton from "../../Button/BaseButton";
import { useTranslation } from "react-i18next";
import "../../../../assets/style/modalStyle/postNews.scss";

import { useDispatch, useSelector } from "react-redux";

import { dealSelector } from "../../../../services/selector/index.";
import {
  editDeal,
  getDetailDeal,
  setDataDetail,
  setOpenEditDeals,
} from "../../../../services/slice/DealSlice";
import moment from "moment/moment";
import { useEffect } from "react";
import { checkNumber, isNumeric } from "../../../../utils/functionCommon";
import TabDeals from "../../Tabs/TabDeals";
import { IconSave } from "../../../../assets/icon";

const ModalEditDeal = ({ title }) => {
  const [defaultValue, setDefaultValue] = useState("");
  const dealState = useSelector(dealSelector);
  const [image, setImage] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { detailByID } = dealState;
  const { id } = detailByID;
  const [datapost, setDataPost] = useState({});
  useEffect(() => {
    if (dealState.idDeals) {
      dispatch(setDataDetail({}));
      dispatch(getDetailDeal(dealState.idDeals));
    }
  }, [dispatch, dealState.idDeals]);
  useEffect(() => {
    let firstImage = "";
    let secondImage = "";
    let thirdImage = "";
    detailByID?.image?.map((item) => {
      if (item.index === 1) {
        firstImage = item.urlImage;
      } else if (item.index === 2) {
        secondImage = item.urlImage;
      } else {
        thirdImage = item.urlImage;
      }
    });
    setDataPost({
      title: detailByID.title,
      descriptions: detailByID.descriptions,
      content: detailByID.content,
      numberCustomer: detailByID.numberCustomer ? detailByID.numberCustomer : 0,
      typePreferential: detailByID.typePreferential,
      typePost: detailByID.typePost,
      timeStart: moment(detailByID.timeStart).format("YYYY-MM-DD HH:mm:ss"),
      timeEnd: moment(detailByID.timeEnd).format("YYYY-MM-DD HH:mm:ss"),
      attractGroup: detailByID.attractGroup,
      displayRange: detailByID.displayRange,
      firstImage: firstImage,
      secondImage,
      thirdImage,
      attractGroupDetail: detailByID.attractGroupDetail,
    });
  }, [
    detailByID.title,
    detailByID.displayRange,
    detailByID.descriptions,
    detailByID.content,
    detailByID.numberCustomer,
    detailByID.typePreferential,
    detailByID.typePost,
    detailByID.urlImage,
    detailByID.attractGroup,
    detailByID.timeStart,
    detailByID.timeEnd,
    detailByID.image,
  ]);
  useEffect(() => {
    setDefaultValue(datapost.typePost);
  }, [datapost.typePost]);
  const handleSave = () => {
    const firstTime = new Date(datapost.timeStart).getTime();
    const secondTime = new Date(datapost.timeEnd).getTime();
    if (image.size > 2 * 1024 * 1024) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });
      return;
    }

    if (
      datapost.typePreferential === 2 &&
      !isNumeric(datapost.numberCustomer)
    ) {
      setError({
        isError: true,
        msg: "Dung lượng ảnh phải nhỏ hơn < 2MB",
      });

      return;
    }
    if (secondTime - firstTime <= 0) {
      setError({
        isError: true,
        msg: "Thời gian bắt đầu phải nhỏ hơn Thời gian kết thúc",
      });
      return;
    }
    if (datapost.displayRange === 1 && !datapost.attractGroup.length) {
      setError({
        isError: true,
        msg: "Nhóm khách hàng nhận ưu đãi không xác định",
      });
      return;
    }
    if (
      datapost.displayRange === 1 &&
      datapost.numberCustomer &&
      (!checkNumber(datapost.numberCustomer) || datapost.numberCustomer < 0)
    ) {
      setError({
        isError: true,
        msg: "Bạn nhập sai định dạng. Vui lòng nhập lại",
      });
      return;
    }

    const formPost = new FormData();
    formPost.append("secondImage", datapost.secondImage);
    formPost.append("firstImage", datapost.firstImage);
    formPost.append("thirdImage", datapost.thirdImage);
    formPost.append("title", datapost.title);
    formPost.append("descriptions", datapost.descriptions);
    if (datapost.lastUpdate) {
      formPost.append("lastUpdate", datapost.lastUpdate);
    }
    formPost.append("id", Number(id));
    formPost.append(
      "content",
      datapost.content.replace(
        new RegExp(window.SERVER_URL, "g"),
        window.SERVER_CLIENT_URL
      )
    );
    formPost.append("numberCustomer", datapost.numberCustomer);
    formPost.append("timeStart", datapost.timeStart);
    formPost.append("timeEnd", datapost.timeEnd);
    formPost.append("typePreferential", datapost.typePreferential);
    formPost.append("typePost", datapost.typePost);
    formPost.append("displayRange", datapost.displayRange);
    if (datapost?.attractGroup?.length) {
      formPost.append("attractGroup", JSON.stringify(datapost.attractGroup));
    }
    dispatch(editDeal(formPost));
  };
  const handCancel = () => {
    dispatch(setOpenEditDeals({ isOpen: false, id: "" }));
  };

  const handleChangeTab = (key) => {
    setDataPost({
      ...datapost,

      typePost: parseInt(key),
    });
  };
  const [error, setError] = useState({
    isError: false,
    msg: "",
  });

  return (
    <>
      <Modal
        maskClosable={false}
        className="wrapperModalPostNews"
        title={t(title)}
        centered
        width={1300}
        open={dealState.isOpenModalEditDeal}
        // onOk={() => setOpen(false)}
        onCancel={handCancel}
        footer={[
          <BaseButton
            width={96}
            content={"Lưu"}
            typeBtn="btnOrange"
            icon={<IconSave />}
            handleClick={handleSave}
          />,
        ]}
      >
        <Tabs
          key={defaultValue}
          activeKey={datapost.typePost?.toString()}
          defaultActiveKey={defaultValue}
          onChange={handleChangeTab}
          items={[
            {
              label: t("Viết bài"),
              key: "1",
              children: (
                <TabDeals
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                  img={image}
                />
              ),
            },

            {
              label: t("Nhập link"),
              key: "2",
              children: (
                <TabDeals
                  img={image}
                  error={error}
                  datapost={datapost}
                  setDataPost={setDataPost}
                  setImage={setImage}
                />
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

export default ModalEditDeal;
